import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../utils/storeHooks';
import CloseIcon from '../icons/CloseIcon'
import { Link } from 'react-router-dom';
import { vf } from '../../utils/customTypes';

export type ModalProps = {
    closeModal: vf;
    showModal: boolean
}

const NavMenu = ({ closeModal, showModal }: ModalProps) => {
    
    const { lang } = useAppSelector(store => store.display);

    const [isVisible, setIsVisible] = useState(false);

    useEffect(()=> {
        if (!showModal) {
            setIsVisible(false);
        }
    }, [showModal])

    useEffect(() => {
        // Trigger slide-in after mount
        requestAnimationFrame(() => {
            setIsVisible(true);
        });
    }, []);

    const handleCloseNav = () => {
        setIsVisible(false); // Start slide-out
        closeModal();
    };

    const modalContent = {
        home: {
            en: 'Home',
            ma: 'Kāinga'
        },
        about: {
            en: 'About',
            ma: 'Mō Tukutuku',
        },
        updates: {
            en: 'Updates',
            ma: 'Pūrongo'
        },
    };

    return (
        <div className={`z-99 p-2 h-full w-5/7 md:w-1/4 bg-para-1 fixed top-0 flex flex-col items-center transition-sd`} style={{ transform: isVisible ? 'translateX(0)' : 'translateX(-100%)'}}>
            <div className="w-full flex justify-end mb-2">
                <CloseIcon styles="size-8 relative float-right hover:text-toto-2 hover:cursor-pointer hover:scale-90 transition ease-out duration-600" click={handleCloseNav}/>
            </div>
            <div className='w-[80%] flex flex-col items-start'>
                {
                    Object.entries(modalContent).map(([route, language]) => (
                        <h2 key={route + '_link'} className='cursor-pointer hover:text-kaho-1 transition-slow'>
                            <Link to={'/' + (route === 'home' ? '' : route)} onClick={handleCloseNav}>
                                {language[lang]}
                            </Link>
                        </h2>
                    ))
                }
            </div>
        </div>
    );
};

export default NavMenu